module.exports = __webpack_public_path__ + "static/media/gold-feather.d1db718e.png";